module.exports = __webpack_public_path__ + "img/FINANCEPR1.ea613fed.png";